export default {
      id: "icon-refresh-usage",
      viewBox: "-3.78 -3.47 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-refresh",
      toString: function () {
        return this.url;
      }
    }